<template>
    <div class="container">
        <vrm-form v-if="step === 1" @submit="onSubmit">
            <div class="row">
                <div class="col-sm-12 col-md-10 col-md-offset-1">
                    <h1 class="vrm-page-title">
                        {{
                            $t('mfa.password_wizard_title', {
                                i18nFallback: 'Disabling two-step verification',
                            })
                        }}
                    </h1>
                    <p>
                        {{
                            $t('mfa.password_wizard_description', {
                                i18nFallback:
                                    'You are about to disable 2fa, this will mean that your account will only be protected by a password. We will also remove settings for the other two-step verification methods. This means if you change your mind then you will have to verify your phone number again or scan a new authenticator code.',
                            })
                        }}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-10 col-md-offset-1">
                    <vrm-form-checkbox v-model="userIsSure" :disabled="busy" required>
                        <template v-slot:title>
                            {{
                                $t('mfa.password_wizard_i_am_sure', {
                                    i18nFallback:
                                        'I want to disable two-step verification on this account',
                                })
                            }}
                            (
                            <b>{{ userEmail }}</b>
                            )
                        </template>
                    </vrm-form-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-9 col-md-offset-1">
                    <div class="vrm-form__fieldset-item">
                        <button type="submit" class="sg-btn sg-red" :disabled="busy">
                            {{
                                $t('mfa.password_wizard_disable_mfa', {
                                    i18nFallback: 'Disable two-step verification',
                                })
                            }}
                        </button>
                    </div>
                </div>
            </div>
        </vrm-form>
        <vrm-form v-else-if="step === 2">
            <div class="row">
                <div class="col-xs-12 col-md-10 col-md-offset-1">
                    <h1 class="vrm-page-title">
                        {{ $t('mfa.password_wizard_success_title') }}
                    </h1>
                    <router-link to="base.profile.twofactor">
                        {{ $t('mfa.back_to_settings', { i18nFallback: 'Back to settings' }) }}
                    </router-link>
                </div>
            </div>
        </vrm-form>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute } from '@/vue/decorators/angular-interop';
import WizardMixin from '@/vue/components/pages/mfa/wizards/WizardMixin';
import VrmForm from '@/vue/components/forms/VrmForm';
import VrmFormCheckbox from '@/vue/components/forms/VrmFormCheckbox';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { VrmFormCheckbox, VrmForm },
    mixins: [WizardMixin],
})
@AngularRoute('base.profile.twofactor.password', '/password-only')
@AngularLocaleBundle('mfa')
export default class Password extends Vue {
    step = 1;
    busy = false;

    userIsSure = false;
    showCheckboxReminder = false;

    get userEmail() {
        const user = this.$store.state.UserService.user;
        return user ? user.email : '';
    }

    async onSubmit() {
        if (!this.userIsSure) {
            this.showCheckboxReminder = true;
            return;
        }
        this.busy = true;
        try {
            if (await this.$store.dispatch('MfaService/passwordOnly')) {
                this.step = 2;
            }
        } finally {
            this.busy = false;
        }
    }
}
</script>
